import { Link } from 'react-router-dom';

// mui
import Avatar from '@mui/material/Avatar';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Typography from '@mui/material/Typography';

// types
type RoomCardProps = {
    description: string,
    memberCount: number,
    name: string,
    roomId: number,
    thumbnailUrl: string,
}

export default function TopicCard(props: RoomCardProps) {
    const {
        description,
        memberCount,
        name,
        roomId,
        thumbnailUrl,
    } = props;

    return (
        <Card sx={{
            width: "calc(100% - 16px)",
            maxWidth: 980,
            mx: "auto",
            '& > a': {
                color: (theme) => theme.palette.grey[900],
                textDecoration: "none",
            }
        }}>
            <Link to={"/" + roomId}>
                <CardHeader
                    title={name}
                    avatar={
                        <Avatar
                            src={thumbnailUrl}
                            sx={{}}
                            variant="square"
                            aria-label="room-thumbnail"
                        />
                    }
                    subheader={memberCount + "人参加中"}
                    sx={{
                        px: 3,
                        pb: 1,
                        '& .MuiCardHeader-avatar': {
                            mr: { mb: 1, tb: 2 },
                            '& .MuiAvatar-root': {
                                width: 100,
                                height: 100,
                            }
                        },
                        '& .MuiCardHeader-content': {
                            '& .MuiCardHeader-title': {
                                marginBottom: 2,
                                fontSize: 24,
                                fontWeight: 700,
                            },
                            '& .MuiCardHeader-subheader': {
                                fontSize: 14,
                            }
                        }
                    }}
                />
                <CardContent
                    sx={{
                        px: 3,
                        pt: 1,
                    }}
                >
                    <Typography>
                        {description}
                    </Typography>
                </CardContent>
            </Link>
        </Card>
    );
}